export default function PrivacyPage() {
  return (
    <section className="app-section" style={{ paddingTop: "2.5rem" }}>
      <div className="shell readable docs">
        <p className="section-kicker">
          <i className="brand-diamond" aria-hidden /> Legal
        </p>
        <h2 className="section-title">Privacy</h2>
        <p className="section-lead left">Last updated: 11 Sep 2026</p>

        <article className="docs-block">
          <h3>What we collect</h3>
          <p>
            This static site does not require accounts. If you paste a wallet
            address into Portfolio, the lookup runs against a Solana RPC via our
            server-side proxy. We do not use pasted addresses to build marketing
            profiles.
          </p>
        </article>

        <article className="docs-block">
          <h3>Logs & hosting</h3>
          <p>
            Hosting providers and RPC operators may log IP addresses and request
            metadata under their own policies. On-chain activity is public by
            design.
          </p>
        </article>

        <article className="docs-block">
          <h3>Third parties</h3>
          <p>
            Links to StonkFun, Jupiter, Solscan, and similar services are subject
            to those services&apos; privacy terms.
          </p>
        </article>

        <article className="docs-block">
          <h3>Changes</h3>
          <p>
            We may update this notice as the product evolves. Continued use of
            the site after changes constitutes acceptance of the updated notice.
          </p>
        </article>
      </div>
    </section>
  );
}
